import { render } from "./Container.vue?vue&type=template&id=24018813&scoped=true"
const script = {}

import "./Container.vue?vue&type=style&index=0&id=24018813&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24018813"]])

export default __exports__